import { Thermometer } from 'lucide-react';
import { VisitorWarmEvent as VisitorWarmEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: VisitorWarmEventType;
}

// Mirrors INTENT_REASON_LABELS in backend/api/services/visitor_intent.py.
const REASON_LABELS: Record<string, string> = {
  high_intent_pages: 'Viewed a pricing, demo or contact page',
  product_pages: 'Viewed product pages',
  high_page_views: 'Viewed three or more pages',
  cta_clicks: 'Clicked a buying call to action',
  returning_visitor: 'Returning visitor',
  conversation_history: 'Has chatted with the agent before',
};

export default function VisitorWarmEvent({ event }: Props) {
  const payload = event.payload || ({} as VisitorWarmEventType['payload']);
  const reasons = (payload.intent_reasons || [])
    .map((reason) => REASON_LABELS[reason])
    .filter(Boolean);
  const pages = (payload.pages || []).slice(-5);
  const who = payload.company_name || (payload.identified ? 'Identified visitor' : 'Anonymous visitor');

  return (
    <EventShell
      color="orange"
      icon={<Thermometer className="w-3.5 h-3.5" />}
      title={`Warm Visitor · score ${payload.intent_score}`}
      timestamp={event.created_at}
    >
      <p>{who}</p>
      {reasons.length > 0 && <p>{reasons.join(' · ')}</p>}
      {pages.length > 0 && <p>Pages: {pages.join(', ')}</p>}
    </EventShell>
  );
}
